import styled from 'styled-components';
import media from 'src/styles/Media.styled';

const Text = styled.div`
    color: ${({ fontColor }) => fontColor};
    font-size: ${({ fontSize }) => fontSize};
    font-family: ${({ fontFamily }) => fontFamily};
    letter-spacing: ${({ letterSpacing }) => letterSpacing};
    opacity: ${({ opacity }) => opacity};
    margin: ${({ margin }) => margin};
    text-align: ${({ textAlign }) => textAlign};
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    cursor: ${({ cursor }) => cursor};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    display: ${({ display }) => display};
    align-items: baseline;
    white-space : ${({ whiteSpace }) => whiteSpace};
    &:after {
        content: '${({ showRedAsterisk }) => (showRedAsterisk ? '*' : '')}';
        color: #ff0066;
        padding-left: 3px;
    }
    text-transform: ${({ textTransform }) => textTransform || ''};
    ${media.mobileDevice`
        color: ${({ mbFontColor }) => mbFontColor};
        margin : ${({ mbMargin }) => mbMargin};
    `}
`;

export default Text;
